import braze from 'appboy-web-sdk';
import { getConfig, getLogger } from '../gaia-data/init';

var EVENT_KEY_LOADED_HOME_SCREEN = 'LoadedHomeScreen';
var EVENT_STARTED_COURSE = 'StartedCourse';
var EVENT_COMPLETED_COURSE = 'CompletedCourse';
var EVENT_PERCENTAGE_COMPLETED_COURSE = 'CoursePercentageCompleted';
var EVENT_ADDED_COURSE = 'AddedCourse';
var EVENT_SEQUENCE_COMPLETED = 'Sequence Completed';

var KEY_CLIENT_ID = 'client_id';
var KEY_REGISTRATION_DATE = 'registrationDate';
var KEY_GUI = 'gui';
var KEY_INTERFACE_LANGUAGE = 'interfaceLanguage';
var KEY_ORGANIZATION = 'organization';
var KEY_ORIGIN_LANGUAGE = 'originLanguage';
var KEY_STATUS = 'status';
var KEY_CREATION_DATE = 'creationDate';
var KEY_MODIFICATION_DATE = 'modificationDate';
var KEY_VOICE_TYPE = 'voiceType';
var KEY_ORGANIZATION_NAME = 'organizationName';
var KEY_TARGET_LANGUAGE = 'targetLanguage';
var KEY_GROUP_GUIDS = 'groupGuids';
var KEY_NAMESPACE = 'namespace';
var KEY_TERMS_AND_CONDITIONS_ACCEPT_DATE = 'termsAndConditionsAcceptDate';
var KEY_CEFR_LEVEL = 'CEFRLevel';

// these are set in launchpad, which handles the goals, here for reference
// const KEY_USAGE_GOAL_DAYS = "usageGoalDays";
// const KEY_USAGE_GOAL_MINUTES = "usageGoalMinutes";

var initBrazeForUser = function initBrazeForUser(userInfo) {
  var brazeKey = getConfig().brazeApiKey;
  if (!brazeKey) {
    getLogger().warn('braze not initialized because no brazeApiKey was specified');
    return;
  }

  var brazeOptions = {
    localization: userInfo.egoUser.interfaceLanguage,
    enableHtmlInAppMessages: true
  };
  braze.initialize(brazeKey, brazeOptions);

  var isUberUser = userInfo.egoUser.namespace === 'uberrewards';

  var userEmail = userInfo.egoUser.email;
  if (isUberUser) {
    userEmail = userInfo.egoUser.userField1;
  }
  var interfaceLanguage = userInfo.egoUser.interfaceLanguage;
  if (interfaceLanguage === 'es-419') {
    // AEB-13201, es-419 is not recognized by Braze, update to 'es'
    interfaceLanguage = 'es-ES';
  }

  braze.changeUser(userInfo.userId);
  // braze-standard user info
  braze.getUser().setEmail(userEmail);
  braze.getUser().setFirstName(userInfo.egoUser.firstName);
  braze.getUser().setLastName(userInfo.egoUser.lastName);
  braze.getUser().setLanguage(interfaceLanguage);
  // and the custom fields
  braze.getUser().setCustomUserAttribute(KEY_CLIENT_ID, userInfo.client_id);
  braze.getUser().setCustomUserAttribute(KEY_REGISTRATION_DATE, userInfo.egoUser.registrationDate);
  braze.getUser().setCustomUserAttribute(KEY_GUI, userInfo.egoUser.gui);
  braze.getUser().setCustomUserAttribute(KEY_INTERFACE_LANGUAGE, userInfo.egoUser.interfaceLanguage);
  braze.getUser().setCustomUserAttribute(KEY_ORGANIZATION, userInfo.egoUser.organization);
  braze.getUser().setCustomUserAttribute(KEY_ORIGIN_LANGUAGE, userInfo.egoUser.originLanguage);
  braze.getUser().setCustomUserAttribute(KEY_STATUS, userInfo.egoUser.status);
  braze.getUser().setCustomUserAttribute(KEY_CREATION_DATE, userInfo.egoUser.creationDate);
  braze.getUser().setCustomUserAttribute(KEY_MODIFICATION_DATE, userInfo.egoUser.modificationDate);
  if (userInfo.egoUser.preferences) {
    braze.getUser().setCustomUserAttribute(KEY_VOICE_TYPE, userInfo.egoUser.preferences.voiceType);
  }
  braze.getUser().setCustomUserAttribute(KEY_ORGANIZATION_NAME, userInfo.egoUser.organizationName);
  if (userInfo.egoUser.targetLanguage) {
    braze.getUser().setCustomUserAttribute(KEY_TARGET_LANGUAGE, userInfo.egoUser.targetLanguage.language);
    braze.getUser().setCustomUserAttribute(KEY_CEFR_LEVEL, userInfo.egoUser.targetLanguage.level);
  }
  if (Array.isArray(userInfo.egoUser.groupGuids)) {
    braze.getUser().setCustomUserAttribute(KEY_GROUP_GUIDS, userInfo.egoUser.groupGuids.join());
  }
  braze.getUser().setCustomUserAttribute(KEY_NAMESPACE, userInfo.egoUser.namespace);
  if (userInfo.egoUser.termsAndConditionsAcceptDate) {
    braze.getUser().setCustomUserAttribute(KEY_TERMS_AND_CONDITIONS_ACCEPT_DATE, userInfo.egoUser.termsAndConditionsAcceptDate);
  } else {
    // we don't have the terms accept date as separate data but they must do it to register
    braze.getUser().setCustomUserAttribute(KEY_TERMS_AND_CONDITIONS_ACCEPT_DATE, userInfo.egoUser.registrationDate);
  }

  braze.display.automaticallyShowNewInAppMessages();
  braze.openSession();
};

var logBrazeEvent = function logBrazeEvent(eventName, payload) {
  var brazeKey = getConfig().brazeApiKey;
  if (brazeKey) {
    braze.logCustomEvent(eventName, payload);
  }
};

export var brazeHelper = {
  initBrazeForUser: initBrazeForUser,
  logBrazeEvent: logBrazeEvent,
  EVENT_KEY_LOADED_HOME_SCREEN: EVENT_KEY_LOADED_HOME_SCREEN,
  EVENT_ADDED_COURSE: EVENT_ADDED_COURSE,
  EVENT_STARTED_COURSE: EVENT_STARTED_COURSE,
  EVENT_SEQUENCE_COMPLETED: EVENT_SEQUENCE_COMPLETED,
  EVENT_COMPLETED_COURSE: EVENT_COMPLETED_COURSE,
  EVENT_PERCENTAGE_COMPLETED_COURSE: EVENT_PERCENTAGE_COMPLETED_COURSE
};